import PropTypes from 'prop-types'
import classNames from 'classnames'
import { animated, useSpring } from 'react-spring'
import styles from './styles/ProgressBar.css'

export const ProgressBar = ({ progress, color = 'blue' }) => {
  const classes = {
    inner: classNames(styles.inner, {
      [styles.blue]: color === 'blue',
      [styles.red]: color === 'red'
    })
  }
  const style = useSpring({
    from: { width: '0%' },
    width: `${progress}%`
  })
  return (
    <div className={styles.bg}>
      <animated.div className={styles.bar} style={style}>
        <div className={classes.inner} />
      </animated.div>
    </div>
  )
}

ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
  color: PropTypes.oneOf([
    'red',
    'blue'
  ])
}

export default ProgressBar
